function KnobDownSmall() {
  return (
    <svg
      width="8"
      height="4"
      viewBox="0 0 8 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33329 0.666687L4.157 3.27978C4.13638 3.29676 4.11191 3.31024 4.08496 3.31943C4.05801 3.32862 4.02913 3.33335 3.99996 3.33335C3.97079 3.33335 3.9419 3.32862 3.91496 3.31943C3.88801 3.31024 3.86353 3.29676 3.84292 3.27978L0.666626 0.666687"
        stroke="#150828"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default KnobDownSmall;
